import { render, staticRenderFns } from "./CustomMoreList.vue?vue&type=template&id=514d7854&scoped=true&"
import script from "./CustomMoreList.vue?vue&type=script&lang=js&"
export * from "./CustomMoreList.vue?vue&type=script&lang=js&"
import style0 from "./CustomMoreList.vue?vue&type=style&index=0&id=514d7854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d7854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('514d7854')) {
      api.createRecord('514d7854', component.options)
    } else {
      api.reload('514d7854', component.options)
    }
    module.hot.accept("./CustomMoreList.vue?vue&type=template&id=514d7854&scoped=true&", function () {
      api.rerender('514d7854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomMoreList.vue"
export default component.exports